<template>
  <li>
    <a ref="tabLink" class="nav-link" :class="{ 'active': active }" data-toggle="tab" :data-tabid="tabIdentifier" :href="'#' + tabIdentifier">
      <span class="content"><slot /></span>
      <span v-if="badgeCount > 0" :class="['badge', 'ml-2', badgeClass]">{{badgeCount}}</span>
      <span v-if="errorCount + formErrorCount > 0" :class="['badge', 'ml-2', 'badge-danger']">{{errorCount + formErrorCount}}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    tabid: String,
    first: Boolean,
    badgeCount: {
      type: Number,
      default: 0
    },
    badgeClass: {
      type: String,
      default: 'badge-primary'
    },
    errorCount: {
      type: Number,
      default: 0
    }
  },
  inject: {
    tabbedBox: {
      default() {
        return { }
      }
    }
  },
  computed: {
    tabIdentifier() {
      return this.$data.tabBoxId + '-' + this.$props.tabid
    }
  },
  data() {
    return {
      tabBoxId: 0,
      active: false,
      formErrorCount: 0
    }
  },
  mounted() {
    this.registerTabItem()

    var tabBox = this.findComponentParent(this.$parent, 'TabbedBox')
    if(tabBox)
      this.$data.tabBoxId = tabBox.uuid
    
    this.$data.active = this.$props.first
    
    $(this.$refs.tabLink).on('shown.bs.tab', this.onTabShown)
    $(this.$refs.tabLink).on('hidden.bs.tab', this.onTabHidden)
  },
  beforeDestroy() {
    $(this.$refs.tabLink).off('shown.bs.tab', this.onTabShown)
    $(this.$refs.tabLink).off('hidden.bs.tab', this.onTabHidden)
  },
  destroyed() {
    this.unregisterTabItem()
  },
  methods: {
    registerTabItem() {
      this.tabbedBox.registerTabItem && this.tabbedBox.registerTabItem(this)
    },
    unregisterTabItem() {
      this.tabbedBox.unregisterTabItem && this.tabbedBox.unregisterTabItem(this)
    },
    show() {
      $(this.$refs.tabLink).tab('show')
    },
    onTabShown(e) {
      this.$emit('show')
    },
    onTabHidden(e) {
      this.$emit('hidden')
    },
    displayErrors(tabPage) {
      
      this.formErrorCount = 0
      if(tabPage.$refs.tabPage) {
        var errorInputList = $(tabPage.$refs.tabPage).find('.is-invalid')

        this.formErrorCount = errorInputList.length
      }
    }
  }
}
</script>